import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed, watch, } from 'vue';
import VerticalDividedDialog from '@/templates/VerticalDividedDialog.vue';
import { initAutoLc } from '@/locales/ko/views/delivery_charge_dialog';
import { deliveryChargeActionType } from '@/vuex-store/delivery-charge-dialog/actions';
import vuexStore from '@/vuex-store';
import { alertActionType } from '@/vuex-store/alert/actions';
import { i18n } from '@/locales';
import { waitTransition } from '@/utils';
import ChargeForm from './DeliveryChargeForm.vue';
import ChargeList from './DeliveryChargeList.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const lc = initAutoLc();
        const lcDialog = initAutoLc('dialog_cancel_edit.');
        const isDialogOpen = computed(() => vuexStore.state.deliveryChargeDialog.isDeliveryChargeDialogOpen);
        const storeDetail = computed(() => vuexStore.state.deliveryChargeDialog.storeDetail);
        const toggleForm = computed(() => (vuexStore.state.deliveryChargeDialog.toggleForm ? 'ratio-8-2' : 'ratio-full'));
        /**
         * 변경 확인창
         */
        const confirm = () => vuexStore.dispatch(alertActionType.confirm, {
            headerTitle: lcDialog('title'),
            bodyContent: i18n.t('common.confirm_before_cancel'),
            btnConfig: [
                {
                    text: 'cancel',
                    cssClass: 'outlined info',
                },
                {
                    text: 'ok',
                    cssClass: 'danger',
                },
            ],
        });
        /**
         * 취소 핸들러
         */
        const handleClickCancelDialogBtn = async () => {
            try {
                await vuexStore.dispatch(deliveryChargeActionType.confirmChanged, confirm);
            }
            catch (error) {
                console.log('deliveryCharge/handleClickCancelDialogBtn', error);
                vuexStore.dispatch(deliveryChargeActionType.dialogClose);
                await waitTransition();
                vuexStore.dispatch(deliveryChargeActionType.reset);
            }
        };
        const handleClickApplyDialogBtn = () => { };
        /**
         * originForm 초기화
         */
        watch(() => vuexStore.state.deliveryChargeDialog.isDeliveryChargeDialogOpen, (value) => {
            // 닫힐 때는 작동 필요 x
            if (!value) {
                return;
            }
            vuexStore.dispatch(deliveryChargeActionType.setOriginForm);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(VerticalDividedDialog, {
                "is-open": isDialogOpen.value,
                "on-apply": handleClickApplyDialogBtn,
                "on-cancel": handleClickCancelDialogBtn,
                "has-footer": false,
                "has-left-title": false,
                "has-right-title": false,
                "dialog-css-class": toggleForm.value,
                width: 1880,
                height: 900
            }, {
                title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(lc)('header.title')) + " / " + _toDisplayString(storeDetail.value?.name), 1 /* TEXT */)
                ]),
                leftContent: _withCtx(() => [
                    _createVNode(ChargeList)
                ]),
                rightContent: _withCtx(() => [
                    _createVNode(ChargeForm)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["is-open", "dialog-css-class"]));
        };
    }
});
